import {IRoutableModule} from '../../router/routing.infra';
import {reactivateAccountRouteLoader} from './reactivate-account.loader';

const ReactivateAccountView = () => null;

export default {
    loader: reactivateAccountRouteLoader,
    Component: ReactivateAccountView
} as IRoutableModule;
